import React from 'react';
import { MembershipAttributes, ProfileAttributes } from '@loyalty/shared-common/profile-api-client';
import { BlockedMemberMarker } from './BlockedMemberMarker';
import { DeniedMemberMarker } from './DeniedUserMarker';
import { MarkerProps } from './types';
import { TestUserMarker } from './TestUserMarker';

export function getUserMarkers(
  profile: ProfileAttributes,
  membership?: MembershipAttributes,
  props?: MarkerProps,
): React.ReactElement[] {
  const markers: React.ReactElement[] = [];

  if (membership?.blocked) {
    markers.push(<BlockedMemberMarker key="blocked" {...props} />);
  }

  if (profile?.isTestUser) {
    markers.push(<TestUserMarker key="test" {...props} />);
  }

  if (membership?.accessDenied) {
    markers.push(<DeniedMemberMarker key="denied" {...props} />);
  }

  return markers;
}
